import { Box } from '@mui/material';
import type ProductPublishJobStore from '../../../UserData/_stores/Store/ProductPublish/ProductPublishJobStore';

type Props = {
	job: ProductPublishJobStore
}

export default function ProductPublishJobThumbnail(props: Props) {
	const thumbnail = props.job.get('thumbnail')
	const title = props.job.get('title')

	if (thumbnail) {
		return <Box
			component="img"
			src={thumbnail}
			alt={title}
			sx={{
				width: 44,
				height: 44,
				flex: '0 0 44px',
				borderRadius: 1,
				border: 1,
				borderColor: 'divider',
				objectFit: 'cover',
				bgcolor: 'background.default',
				display: 'block',
			}}
		/>
	}

	return <Box
		component="div"
		sx={{
			width: 44,
			height: 44,
			flex: '0 0 44px',
			borderRadius: 1,
			border: 1,
			borderColor: 'divider',
			bgcolor: 'background.default',
		}}
	/>
}
